import { isNativePlatform } from '@/utils/nativePlugins';

const SW_PATH = '/sw.js';

const isRefusedContext = (): boolean => {
  if (!import.meta.env.PROD) return true;
  try {
    if (window.self !== window.top) return true;
  } catch {
    return true;
  }
  const host = window.location.hostname;
  if (host.startsWith('id-preview--') || host.startsWith('preview--')) return true;
  const blocked = ['lovableproject.com', 'lovableproject-dev.com', 'beta.lovable.dev'];
  if (blocked.some((d) => host === d || host.endsWith(`.${d}`))) return true;
  if (new URLSearchParams(window.location.search).get('sw') === 'off') return true;
  try {
    if (isNativePlatform()) return true;
  } catch {
    // ignore
  }
  return false;
};

const unregisterAppWorkers = async () => {
  try {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.allSettled(
      regs
        .filter((r) => [r.active, r.waiting, r.installing].some((w) => w?.scriptURL.endsWith(SW_PATH)))
        .map((r) => r.unregister()),
    );
  } catch {
    // ignore
  }
};

/** Single registrar for the app-shell service worker. */
export const registerServiceWorker = () => {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  if (isRefusedContext()) {
    void unregisterAppWorkers();
    return;
  }
  import('virtual:pwa-register')
    .then(({ registerSW }) => registerSW({ immediate: true }))
    .catch((e) => console.warn('Service worker registration failed:', e));
};
